export default __webpack_public_path__ + "static/media/app-showcase-image-05.3cbdd456.png";